import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';

class SsoPremiumServicesWizardHostComponentCtrl implements ng.IController {
    wizard: mgoAngularWizard.Wizard<StoragePremiumServiceSubscriptionCreationDto>;
    wizardName = 'SsoPremiumServicesWizardHostComponentCtrl';
    wizardContext: StoragePremiumServiceSubscriptionCreationDto;
    onFinish: (servicePackage: StoragePremiumServicePackage) => any;
    disableServicePackageChoice: boolean = false;
    modalHeader: string;

    constructor(private WizardHandler: mgoAngularWizard.WizardHandler<any>) {}

    $doCheck(): void {
        if (this.wizard) {
            switch (this.wizard.currentStepNumber()) {
                case 1:
                    this.modalHeader =
                        'PRISMA allocation algorithms - Select Service package';
                    break;
                case 2:
                    this.modalHeader =
                        'PRISMA allocation algorithms - Overview';
                    break;
            }
            return;
        }

        const wizard: mgoAngularWizard.Wizard<StoragePremiumServiceSubscriptionCreationDto> =
            this.WizardHandler.wizard(this.wizardName);

        if (wizard) {
            this.wizard = wizard;
            this.resetWizard();
            if (this.wizardContext != null) {
                this.wizard.context = this.wizardContext;
                this.disableServicePackageChoice = true;
                this.wizard.setEditMode(false);
                this.wizard.goTo(0);
            }
        }
    }

    private resetWizard(): void {
        Object.keys(this.wizard.context).forEach(
            (key) => delete this.wizard.context[key]
        );
    }
}

angular.module('app').component('pkpSsoPremiumServicesWizardHost', {
    controller: SsoPremiumServicesWizardHostComponentCtrl,
    template:
        require('app/sso-premium-services-wizard/sso-premium-services-wizard-host.component.html'),
    bindings: {
        onFinish: '&',
        back: '&',
        wizardContext: '=',
        isUpgrade: '<',
        closeConfirmationPageOnBack: '<',
        modalHeader: '='
    }
});
